<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-edit"></i> แก้ไข DF</h4>
          <b-row>
            <b-col cols="12" md="6">
              <b-col cols="12">
                <b-form-group
                  block
                  label-size="sm"
                  label="แพทย์:"
                  label-cols="2"
                  label-align="right"
                  class="mb-1"
                >
                  <b-form-select
                    size="sm"
                    v-model="selectedDoctor"
                    :options="doctorsList"
                    text-field="fullName"
                    value-field="uid"
                  >
                    <template #first>
                      <b-form-select-option :value="null"
                        >-- ทุกแพทย์ --</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  block
                  label-size="sm"
                  label="วันที่:"
                  label-cols="2"
                  label-align="right"
                  invalid-feedback="*กรุณาเลือกวันที่"
                  :state="Boolean(dateRange[0] && dateRange[1])"
                >
                  <date-picker
                    v-model="dateRange"
                    type="date"
                    range
                    format="DD MMM YY"
                    :shortcuts="dateRangeShortcuts"
                    :disabled-date="notAfterToday"
                    placeholder="เลือกวันที่ต้องการค้นหา"
                    input-class="form-control form-control-sm"
                  ></date-picker>
                </b-form-group>
              </b-col>
            </b-col>
            <b-col cols="6" md="3" lg="2">
              <b-button class="float-right" variant="primary" @click="fetchReport">
                แสดงข้อมูล
              </b-button>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="7" md="6">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                first-number
                last-number
                pills
                limit="10"
              ></b-pagination>
            </b-col>
          </b-row>

          <b-table
            ref="dfCorrectionTable"
            class="my-0"
            small
            sort-icon-left
            head-variant="light"
            :busy="tableBusy"
            :items="receiptItemList"
            :fields="fields"
            sort-by="creationDt"
            :sort-desc="true"
            :responsive="true"
            show-empty
            sticky-header="calc(100vh - 300px)"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template #cell(index)="row">{{ row.index + 1 }}.</template>
            <template #cell(creationDt)="row">
              {{ formatDate(row.value) }}
            </template>
            <template #cell(paidDf)="row">
              {{ formatNumber(row.value) }}
            </template>
            <template #cell(paidCf)="row">
              {{ formatNumber(row.value) }}
            </template>
            <template #cell(paid)="row">
              {{ formatNumber(row.value) }}
            </template>
            <template #cell(dfStatus)="row">
              <b-badge
                v-if="row.item.hasDfCorrection"
                variant="warning"
                class="cursor-pointer"
                @click="openHistoryModal(row.item)"
              >
                แก้ไขแล้ว
              </b-badge>
              <b-badge v-else variant="light">ปกติ</b-badge>
            </template>
            <template #cell(action)="row">
              <b-button
                size="xs"
                variant="outline-primary"
                @click="openCorrectionModal(row.item)"
              >
                <i class="fas fa-edit"></i> แก้ไข DF
              </b-button>
              <b-button
                v-if="row.item.hasDfCorrection"
                size="xs"
                variant="outline-info"
                @click="openHistoryModal(row.item)"
                class="ml-1"
              >
                <i class="fas fa-history"></i>
              </b-button>
            </template>
            <template #empty>
              <p class="text-center text-muted my-2">
                ไม่มีข้อมูลให้แสดง
              </p>
            </template>
          </b-table>
        </div>
      </div>

      <DfCorrectionModal
        ref="dfCorrectionModal"
        @correctionSaved="onCorrectionSaved"
        @error="onError"
      />
      <DfCorrectionHistoryModal ref="dfCorrectionHistoryModal" />
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DfCorrectionModal from "@/components/modal/DfCorrectionModal";
import DfCorrectionHistoryModal from "@/components/modal/DfCorrectionHistoryModal";
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import moment from "moment";

export default {
  name: "DFCorrection",
  components: {
    DfCorrectionModal,
    DfCorrectionHistoryModal,
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      tableBusy: false,
      selectedDoctor: null,
      dateRange: [],
      receiptItemList: [],
      currentPage: 1,
      perPage: 100,
      fields: [
        { key: "index", label: "" },
        {
          key: "creationDt",
          label: "วันที่",
          sortable: true,
          class: "narrow-spacing",
        },
        { key: "dn", label: "DN.", class: "narrow-spacing" },
        { key: "patientFullName", label: "ชื่อคนไข้", class: "narrow-spacing" },
        { key: "itemName", label: "รายการรักษา", class: "narrow-spacing" },
        { key: "doctorFullName", label: "แพทย์", class: "narrow-spacing" },
        { key: "paid", label: "ชำระ", class: "text-right" },
        { key: "paidDf", label: "DF", class: "text-right" },
        { key: "paidCf", label: "CF", class: "text-right" },
        { key: "dfStatus", label: "สถานะ" },
        { key: "action", label: "", class: "text-center" },
      ],
    };
  },
  created() {
    this.dateRange = [this.today, this.today];
  },
  computed: {
    ...mapGetters({
      doctorsList: "moduleUser/getDoctorList",
      isAccessMenu: "moduleUser/getIsAccessMenu",
      userInfo: "moduleUser/getUserInfo",
      dateRangeShortcuts: "moduleMaster/getDateRangeShortcuts",
    }),
    rows() {
      return this.receiptItemList.length;
    },
    today() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      return today;
    },
    dateFrom() {
      return this.dateRange[0]
        ? moment(this.dateRange[0]).startOf("day").format()
        : "";
    },
    dateTo() {
      return this.dateRange[1]
        ? moment(this.dateRange[1]).endOf("day").format()
        : "";
    },
  },
  methods: {
    ...mapActions({
      fetchReceiptItems: "moduleDfCorrection/fetchReceiptItems",
    }),
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY");
      } else {
        return "";
      }
    },
    formatNumber(num) {
      return Math.round(num * 100) / 100;
    },
    notAfterToday(date) {
      return date > new Date(new Date().setHours(0, 0, 0, 0));
    },
    async fetchReport() {
      if (!this.dateRange[0] || !this.dateRange[1]) return;
      this.tableBusy = true;
      this.isLoading = true;
      try {
        const res = await this.fetchReceiptItems({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          startDt: this.dateFrom,
          endDt: this.dateTo,
          actionUid: this.selectedDoctor,
        });
        this.receiptItemList = res.data.report || res.data || [];
      } catch (err) {
        this.$refs.Dialog.showToast("danger", "ไม่สามารถโหลดข้อมูลได้");
      } finally {
        this.tableBusy = false;
        this.isLoading = false;
      }
    },
    openCorrectionModal(item) {
      this.$refs.dfCorrectionModal.show(item, this.doctorsList);
    },
    openHistoryModal(item) {
      this.$refs.dfCorrectionHistoryModal.show(item);
    },
    onCorrectionSaved() {
      this.fetchReport();
      this.$refs.Dialog.showToast("success", "บันทึกการแก้ไข DF สำเร็จ");
    },
    onError(msg) {
      this.$refs.Dialog.showToast("danger", msg);
    },
  },
};
</script>
